/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterConstraintBaseForNumber extends models.ParameterConstraintBase {
    getFixupPrototypeFunction() { return ParameterConstraintBaseForNumber.fixupPrototype; }

    static newInstance(model: Partial<ParameterConstraintBaseForNumber>): ParameterConstraintBaseForNumber {
        let obj = Object.assign(new ParameterConstraintBaseForNumber(), model);
        ParameterConstraintBaseForNumber.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterConstraintBaseForNumber>): ParameterConstraintBaseForNumber {
        if (!model) return null;
        return ParameterConstraintBaseForNumber.newInstance(<ParameterConstraintBaseForNumber> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterConstraintBaseForNumber) {
        if (!obj) return;

        models.ParameterConstraintBaseForNumber.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterConstraintBaseForNumber): boolean {
        if (models.ParameterConstraintBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterConstraintBaseForNumber.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
